// extracted by mini-css-extract-plugin
export default {"fullWidth":"gm-z","image":"hm-z","lazyLoadPicture":"im-z","lazyLoadSpinner":"jm-z","lazyLoadSpin":"km-z","lazyLoadImage":"lm-z","hasStyledAspectRatio":"mm-z"};